import Card from '../../../../atoms/card/Card';
import ClassProgressBarChart from '../../../../components/classProgressBarChart/ClassProgressBarChart';
import useClassProgressUnits from './useClassProgressUnits';

const ClassProgressUnits = () => {
  const { data, isLoading } = useClassProgressUnits();

  return (
    <Card variant='outlined'>
      <ClassProgressBarChart data={data} isLoading={isLoading} />
    </Card>
  );
};

export default ClassProgressUnits;
